import {
  WorkspaceActionTypes,
  ISetCurrentWorkspacePayload,
  ICreateWorkspacePayload,
  ICreateWorkspaceSuccessResponseBody,
  IRenameWorkspacePayload,
  IRenameWorkspaceSuccessPayload,
  IDeleteWorkspacesPayload,
  IDeleteWorkspacesSuccessPayload,
  IChangeSelectedWorkspacesPayload,
} from './types'

export const resetWorkspaces = () => ({
  type: WorkspaceActionTypes.RESET_WORKSPACES,
})

export const resetCurrentWorkspace = () => ({
  type: WorkspaceActionTypes.RESET_CURRENT_WORKSPACE,
})

export const setCurrentWorkspace = (payload: ISetCurrentWorkspacePayload) => ({
  type: WorkspaceActionTypes.SET_CURRENT_WORKSPACE,
  payload,
})

export const createWorkspace = (payload: ICreateWorkspacePayload) => ({
  type: WorkspaceActionTypes.CREATE_WORKSPACE,
  payload,
})

export const createWorkspaceSuccess = (payload: ICreateWorkspaceSuccessResponseBody) => ({
  type: WorkspaceActionTypes.CREATE_WORKSPACE_SUCCESS,
  payload,
})

export const createWorkspaceFailure = () => ({
  type: WorkspaceActionTypes.CREATE_WORKSPACE_FAILURE,
})

export const renameWorkspace = (payload: IRenameWorkspacePayload) => ({
  type: WorkspaceActionTypes.RENAME_WORKSPACE,
  payload,
})

export const renameWorkspaceSuccess = (payload: IRenameWorkspaceSuccessPayload) => ({
  type: WorkspaceActionTypes.RENAME_WORKSPACE_SUCCESS,
  payload,
})

export const renameWorkspaceFailure = () => ({
  type: WorkspaceActionTypes.RENAME_WORKSPACE_FAILURE,
})

export const deleteWorkspaces = (payload: IDeleteWorkspacesPayload) => ({
  type: WorkspaceActionTypes.DELETE_WORKSPACES,
  payload,
})

export const deleteWorkspacesSuccess = (payload: IDeleteWorkspacesSuccessPayload) => ({
  type: WorkspaceActionTypes.DELETE_WORKSPACES_SUCCESS,
  payload,
})

export const deleteWorkspacesFailure = () => ({
  type: WorkspaceActionTypes.DELETE_WORKSPACES_FAILURE,
})

export const changeSelectedWorkspaces = (payload: IChangeSelectedWorkspacesPayload) => ({
  type: WorkspaceActionTypes.CHANGE_SELECTED_WORKSPACES,
  payload
})

export const unselectWorkspaces = () => ({
  type: WorkspaceActionTypes.UNSELECT_WORKSPACES,
})

export const selectAllWorkspaces = () => ({
  type: WorkspaceActionTypes.SELECT_ALL_WORKSPACES,
})
